module.exports = __webpack_public_path__ + "img/participant-select-desktop-en.df9d2f49.jpg";